import {create} from 'zustand';
import {AddressUpdateModalDisplayStore} from './types';

export const useAddressUpdateModalDisplayStore = create<AddressUpdateModalDisplayStore>(set => ({
	shownByBeneficiary: {},
	markAsShown: beneficiaryCode =>
		set(state => ({
			shownByBeneficiary: {
				...state.shownByBeneficiary,
				[beneficiaryCode]: true,
			},
		})),
	resetDisplayControl: () => set({shownByBeneficiary: {}}),
}));
